var React = require('react');
var createReactClass = require('create-react-class');
var marked = require('marked');

var ContentMarkDown = createReactClass( {
	rawMarkup: function() {
	    var rawMarkup = marked(this.props.payload.toString());
	    return { __html: rawMarkup };
	},

	render: function () {
		return (<div dangerouslySetInnerHTML={this.rawMarkup()} />);
	}
});

module.exports = ContentMarkDown;



// WEBPACK FOOTER //
// ./src/common/routes/components/contentMarkDown.jsx